module.exports = __webpack_public_path__ + "static/media/human-advantage-off-app-provider-icon.63d0d29c.svg";